import VacationUser from 'features/vacations/vacationUser';
import DayOffUser from 'features/dayOff/dayOffUser';
import Breadcrumbs from 'shared/components/breadcrumbs/Breadcrumbs';
import { useTitle } from '../helpers';

/**
 * @page DayOffUserPage
 */

const DayOffUserPage = () => {
  useTitle('Отгул');

  return <DayOffUser />;
};

export default DayOffUserPage;
